import { Button, Icons } from '@commenda/kakashi';

import { IndirectTaxSummaryCard } from '../../common';
import { IndirectTaxFilingsHelper } from '../helpers';

interface IndirectTaxFilingDetailMetricsProps {
  amountDue: number | null;
  currency: string;
  transactionCount: number;
  filedOn: string;
  onViewTransactions: () => void;
}

const IndirectTaxFilingDetailMetrics = ({
  amountDue,
  currency,
  transactionCount,
  filedOn,
  onViewTransactions,
}: IndirectTaxFilingDetailMetricsProps) => {
  const formattedAmount =
    currency && amountDue != null
      ? `${currency} ${IndirectTaxFilingsHelper.formatCurrency(amountDue)}`
      : 'N/A';
  const formattedDate = filedOn
    ? IndirectTaxFilingsHelper.formatFiledOnDate(filedOn)
    : 'Not filed';

  return (
    <div className="grid grid-cols-1 border-b border-border-primary p-3xl pb-0 sm:grid-cols-3 pt-0">
      <IndirectTaxSummaryCard label="Amount due" value={formattedAmount} />

      <IndirectTaxSummaryCard
        label="Transactions"
        value={
          <div className="flex items-end gap-sm">
            {transactionCount}
            <Button variant="brand-link" size="sm" onClick={onViewTransactions}>
              View
              <Icons.ArrowUpRight className="size-3" />
            </Button>
          </div>
        }
      />

      <IndirectTaxSummaryCard label="Filed on" value={formattedDate} />
    </div>
  );
};

export { IndirectTaxFilingDetailMetrics };
